import { render, staticRenderFns } from "./edit-restaurant-category.vue?vue&type=template&id=6aa28f46&scoped=true"
import script from "./edit-restaurant-category.vue?vue&type=script&lang=ts"
export * from "./edit-restaurant-category.vue?vue&type=script&lang=ts"
import style0 from "./edit-restaurant-category.vue?vue&type=style&index=0&id=6aa28f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa28f46",
  null
  
)

export default component.exports